{
    "(None)": "",
    "(save {highestYearlyDiscount}%)": "",
    "{amount} days free": "{amount} zile gratis",
    "{amount} off": "{amount} redus",
    "{amount} off for first {number} months.": "{amount} redus pentru primele {number} luni.",
    "{amount} off for first {period}.": "{amount} redus pentru prima {period}.",
    "{amount} off forever.": "{amount} redus pentru totdeauna",
    "{buyerName} has gifted you a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_one": "",
    "{buyerName} has gifted you a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_few": "",
    "{buyerName} has gifted you a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_other": "",
    "{buyerName} has gifted you a <strong>{duration}-year</strong> {tierName} membership to {siteTitle}": "",
    "{discount}% discount": "Reducere de {discount}%",
    "{duration} membership": "",
    "{field}: {message}": "",
    "{memberEmail} will no longer receive {newsletterName} newsletter.": "{memberEmail} nu va mai primi newsletterul {newsletterName}.",
    "{memberEmail} will no longer receive emails when someone replies to your comments.": "{memberEmail} nu va mai primi emailuri atunci când cineva răspunde la comentariile tale.",
    "{memberEmail} will no longer receive this newsletter.": "{memberEmail} nu va mai primi acest newsletter.",
    "{memberEmail} will no longer receive updates & announcements.": "",
    "{months} month": "",
    "{months} months": "",
    "{months} months free": "",
    "{tierName} membership": "",
    "{trialDays} days free": "{trialDays} zile gratuite",
    "{years} years": "",
    "+1 (123) 456-7890": "",
    "1 month": "",
    "1 month free": "",
    "1 year": "",
    "A gift, just for you": "",
    "Access your RSS feeds": "",
    "Account": "Cont",
    "Account details updated successfully": "",
    "Account settings": "Setări cont",
    "Add a personal note": "",
    "Add a short note to go with your gift": "",
    "Address line 1": "",
    "Address line 2": "",
    "After a free trial ends, you will be charged the regular price for the tier you've chosen. You can always cancel before then.": "După ce expiră perioada de încercare gratuită, vei fi taxat la prețul obișnuit pentru nivelul pe care l-ai ales. Poți anula în orice moment înainte de aceasta.",
    "Already a member?": "Ești deja membru?",
    "An error occurred": "",
    "An unexpected error occured. Please try again or <a>contact support</a> if the error persists.": "A apărut o eroare neașteptată. Te rog încearcă din nou sau <a>contactează suportul</a> dacă eroarea persistă.",
    "Back": "Înapoi",
    "Back to Log in": "Înapoi la Autentificare",
    "Before you go": "",
    "Billing info & receipts": "",
    "Black Friday": "Black Friday",
    "Bluesky": "",
    "Buy": "",
    "Buying for someone else?": "",
    "Cancel anytime.": "Anulează oricând",
    "Cancel subscription": "Anulează abonamentul",
    "Canceled": "",
    "Cancellation reason": "Motivul anulării",
    "Change": "Schimbă",
    "Change plan": "Modifică planul",
    "Check spam & promotions folders": "Verifică dosarele spam & promoții",
    "Check with your mail provider": "Verifică cu furnizorul tău de email",
    "Check your inbox to verify email update": "Verifică-ți căsuța poștală pentru a valida actualizarea adresei de email.",
    "Choose": "Alege",
    "Choose a date from today onwards": "",
    "Choose a date within the next year": "",
    "Choose a delivery date": "",
    "Choose a different plan": "Alege un plan diferit",
    "Choose a plan": "",
    "Choose a tier": "",
    "Choose your newsletters": "Alege-ți newsletterele",
    "City": "",
    "Click here to retry": "Clic aici pentru a reîncerca",
    "Click the confirmation link in your inbox to finish redeeming your membership. If it doesn't arrive within 3 minutes, check your spam folder.": "",
    "Close": "Închide",
    "Code": "",
    "Comment preferences updated.": "",
    "Comments": "Comentarii",
    "Complimentary": "Complimentar",
    "Confirm": "Confirmă",
    "Confirm cancellation": "Confirmă anularea",
    "Confirm subscription": "Confirmă abonamentul",
    "Contact support": "Contactează suportul",
    "Continue": "Continuă",
    "Continue subscription": "Continuă abonamentul",
    "Continue to delivery details": "",
    "Continue to payment": "",
    "Continue with a paid subscription anytime. Your remaining gift period will be added as a free trial.": "",
    "Copied": "",
    "Copy": "",
    "Copy link": "",
    "Could not create Stripe billing portal session": "",
    "Could not create Stripe checkout session": "",
    "Could not sign in. Login link expired.": "Nu s-a putut autentifica. Link-ul de autentificare a expirat.",
    "Could not update email! Invalid link.": "Nu s-a putut actualiza emailul! Link invalid.",
    "Country": "",
    "Create a new contact": "Creează un nou contact",
    "Current plan": "Planul curent",
    "Delete account": "Șterge contul",
    "Delivery date": "",
    "Delivery method": "",
    "Didn't mean to do this? Manage your preferences <button>here</button>.": "Nu ai intenționat acest lucru? Îți poți gestiona preferințele <button>aici</button>.",
    "Don't have an account?": "Nu ai un cont?",
    "Edit": "Editează",
    "Email": "Email",
    "Email confirmation link expired.": "",
    "Email it to them": "",
    "Email newsletter": "Newsletter prin email",
    "Email newsletter settings updated": "",
    "Email preferences": "Preferințe email",
    "Email preferences updated.": "",
    "Emails": "Emailuri",
    "Emails disabled": "Emailuri dezactivate",
    "Ends {offerEndDate}": "Se termină {offerEndDate}",
    "Enjoy {amountOff} off forever.": "",
    "Enjoy {months} free months on us.": "",
    "Enjoy {months} free months on us. You won't be charged until {newBillingDate}.": "",
    "Enjoy a free month on us.": "",
    "Enjoy a free month on us. You won't be charged until {newBillingDate}.": "",
    "Enter code above": "",
    "Enter the recipient's email address": "",
    "Enter your email address": "Introduce adresa ta de email",
    "Enter your name": "Introduce numele tău",
    "Error": "Eroare",
    "Expires {expiryDate}": "Expiră {expiryDate}",
    "Facebook": "",
    "Failed to cancel subscription, please try again": "",
    "Failed to log in, please try again": "",
    "Failed to log out, please try again": "",
    "Failed to open billing portal, please try again": "",
    "Failed to process checkout, please try again": "",
    "Failed to send magic link email": "",
    "Failed to send verification email": "",
    "Failed to sign up, please try again": "",
    "Failed to update account data": "",
    "Failed to update account details": "",
    "Failed to update billing information, please try again": "",
    "Failed to update newsletter settings": "",
    "Failed to update subscription, please try again": "",
    "Failed to verify code, please try again": "",
    "For a friend or colleague": "",
    "Forever": "Pentru totdeauna",
    "Free Trial – Ends {trialEnd}": "Perioadă de probă gratuită - Se încheie {trialEnd}",
    "From": "",
    "Get help": "Obține ajutor",
    "Get in touch for help": "Ia legătura pentru ajutor",
    "Get notified when someone replies to your comment": "Primește notificare când cineva răspunde la comentariul tău",
    "Gift a membership": "",
    "Gift could not be redeemed": "",
    "Gift details": "",
    "Gift duration": "",
    "Gift link copied to clipboard": "",
    "Gift membership": "",
    "Gift redeemed! You're all set.": "",
    "Gift subscription": "",
    "Gift subscriptions are not available right now.": "",
    "Gift value": "",
    "Give feedback on this post": "Oferă feedback pentru acest post",
    "Help! I'm not receiving emails": "Ajutor! Nu primesc emailuri",
    "Here are a few other sites you may enjoy.": "Iată câteva alte site-uri care s-ar putea să-ți placă.",
    "Hi {recipientName},": "",
    "Hide details": "",
    "How would you like to share this gift?": "",
    "I'll share it myself": "",
    "If a newsletter is flagged as spam, emails are automatically disabled for that address to make sure you no longer receive any unwanted messages.": "Dacă un newsletter este marcat ca spam, emailurile sunt automat dezactivate pentru acea adresă pentru a te asigura că nu mai primești mesaje nedorite.",
    "If the spam complaint was accidental, or you would like to begin receiving emails again, you can resubscribe to emails by clicking the button on the previous screen.": "Dacă sesizarea privind spam-ul a fost accidentală, sau doriți să începeți din nou să primiți emailuri, vă puteți reabona la emailuri făcând clic pe butonul de pe ecranul anterior.",
    "If you cancel your subscription now, you will continue to have access until {periodEnd}.": "Dacă anulați abonamentul acum, veți continua să aveți acces până la {periodEnd}.",
    "If you have a corporate or government email account, reach out to your IT department and ask them to allow emails to be received from {senderEmail}": "Dacă aveți un cont de email corporativ sau guvernamental, contactați departamentul IT și cereți-le să permită primirea emailurilor de la {senderEmail}",
    "If you have an account, a login link has been sent to your inbox. If it doesn't arrive in 3 minutes, be sure to check your spam folder.": "Un link de autentificare a fost trimis în inbox-ul tău. Dacă nu ajunge în 3 minute, asigură-te că verifici folderul de spam.",
    "If you have an account, an email has been sent to {submittedEmailOrInbox}. Click the link inside or enter your code below.": "",
    "If you would like to start receiving emails again, the best next steps are to check your email address on file for any issues and then click resubscribe on the previous screen.": "Dacă doriți să începeți să primiți din nou emailuri, cei mai buni pași următori sunt să verificați adresa dvs. de email din fișiere pentru orice probleme și apoi să faceți clic pe reabonare pe ecranul anterior.",
    "If you're not receiving the email newsletter you've subscribed to, here are a few things to check.": "Dacă nu primiți buletinul informativ pe email la care v-ați abonat, iată câteva lucruri de verificat.",
    "If you've completed all these checks and you're still not receiving emails, you can reach out to get support by contacting {supportAddress}.": "Dacă ați completat toate aceste verificări și încă nu primiți emailuri, puteți solicita suport contactând {supportAddress}.",
    "In the event a permanent failure is received when attempting to send a newsletter, emails will be disabled on the account.": "În cazul în care se primește o eroare permanentă la încercarea de a trimite un buletin informativ, emailurile vor fi dezactivate pe cont.",
    "In your email client add {senderEmail} to your contacts list. This signals to your mail provider that emails sent from this address should be trusted.": "În clientul dvs. de email adăugați {senderEmail} în lista de contacte. Acest lucru indică furnizorului dvs. de email că emailurile trimise de la această adresă ar trebui considerate de încredere.",
    "Invalid email address": "",
    "Invalid verification code": "",
    "Jamie Larson": "",
    "jamie@example.com": "",
    "Less like this": "Mai puțin de genul acesta",
    "LinkedIn": "",
    "Make sure emails aren't accidentally ending up in the Spam or Promotions folders of your inbox. If they are, click on \"Mark as not spam\" and/or \"Move to inbox\".": "Asigurați-vă că emailurile nu ajung accidental în folderele Spam sau Promoții ale inbox-ului dvs. Dacă da, faceți clic pe \"Marchează ca fiind nesolicitat\" și/sau \"Mută în inbox\".",
    "Manage": "Administrează",
    "Maybe later": "Poate mai târziu",
    "Membership details": "",
    "Memberships from this email domain are currently restricted.": "",
    "Memberships unavailable, contact the owner for access.": "Membriile nu sunt disponibile, contactați proprietarul pentru acces.",
    "month": "",
    "Monthly": "Lunar",
    "More like this": "Mai multe de genul acesta",
    "More options": "",
    "Name": "Nume",
    "Need more help? Contact support": "Aveți nevoie de mai mult ajutor? Contactați suportul",
    "Newsletters can be disabled on your account for two reasons: A previous email was marked as spam, or attempting to send an email resulted in a permanent failure (bounce).": "Buletinele informative pot fi dezactivate pe contul dvs. din două motive: Un email anterior a fost marcat ca spam, sau încercarea de a trimite un email a rezultat într-o eroare permanentă (respins).",
    "No member exists with this e-mail address.": "",
    "No thanks, I want to cancel": "",
    "Not ready to share? We've also emailed a copy to your inbox.": "",
    "Not receiving emails?": "Nu primești emailuri?",
    "Now": "",
    "Now check your email!": "Acum verifică-ți emailul!",
    "Occasional updates from {siteTitle}": "",
    "Once resubscribed, if you still don't see emails in your inbox, check your spam folder. Some inbox providers keep a record of previous spam complaints and will continue to flag emails. If this happens, mark the latest newsletter as 'Not spam' to move it back to your primary inbox.": "Odată reabonat, dacă încă nu vedeți emailuri în inbox, verificați dosarul de spam. Unii furnizori de inbox păstrează un istoric al sesizărilor de spam anterioare și vor continua să marcheze emailurile. Dacă se întâmplă acest lucru, marcați cel mai recent buletin informativ ca 'Nu este spam' pentru a-l muta înapoi în inbox-ul primar.",
    "Open AOL Mail": "",
    "Open email": "",
    "Open Feedbin": "",
    "Open Gmail": "",
    "Open Hey": "",
    "Open iCloud Mail": "",
    "Open Mail.ru": "",
    "Open Outlook": "",
    "Open Proton Mail": "",
    "Open Yahoo Mail": "",
    "Optional message": "",
    "Permanent failure (bounce)": "Eroare permanentă (respins)",
    "Phone number": "",
    "Plan": "Plan",
    "Plan checkout was cancelled.": "Finalizarea planului a fost anulată.",
    "Plan upgrade was cancelled.": "Actualizarea planului a fost anulată.",
    "Please contact {supportAddress} to adjust your complimentary subscription.": "Vă rugăm să contactați {supportAddress} pentru a ajusta abonamentul dvs. gratuit.",
    "Please enter {fieldName}": "",
    "Please fill in required fields": "Vă rugăm să completați câmpurile necesare",
    "Podcasts": "",
    "Postal code": "",
    "Re-enable emails": "Activează din nou emailurile",
    "Recipient's email": "",
    "Recipient's name": "",
    "Recommendations": "Recomandări",
    "Redeem your gift": "",
    "Redeeming...": "",
    "Renews at {price}.": "Se reînnoiește la {price}.",
    "Resume subscription": "",
    "Retry": "Reîncearcă",
    "Save": "Salvează",
    "Save {amountOff} on your next {durationInMonths} billing cycles. Then {currency}{originalPrice}/{cadence}.": "",
    "Save {amountOff} on your next billing cycle. Then {currency}{originalPrice}/{cadence}.": "",
    "Security verification": "",
    "Send the link below to share it with whoever you'd like.": "",
    "Sending login link...": "Se trimite link-ul de autentificare...",
    "Sending...": "Se trimite...",
    "Share": "",
    "Share a full membership to {siteTitle} with a friend or colleague": "",
    "Share it yourself": "",
    "Show all": "Arată tot",
    "Sign in": "Autentificare",
    "Sign out": "Deconectare",
    "Sign up": "Înregistrare",
    "Signup error: Invalid link": "Eroare la înregistrare: Link invalid",
    "Signups from this email domain are currently restricted.": "",
    "Something went wrong, please try again later.": "",
    "Sorry, no paid plans are available.": "",
    "Sorry, no recommendations are available right now.": "",
    "Sorry, that didn’t work.": "Ne pare rău, nu a funcționat.",
    "Spam complaints": "Reclamații spam",
    "Start {amount}-day free trial": "Începe perioada gratuită de {amount} zile",
    "Starting {startDate}": "Începând cu {startDate}",
    "Starting today": "Începând de astăzi",
    "State": "",
    "Submit feedback": "Trimite feedback",
    "Subscribe": "Abonează-te",
    "Subscribed": "Abonat",
    "Subscription plan updated successfully": "",
    "Success": "Succes",
    "Success! Check your email for magic link to sign-in.": "Succes! Verifică-ți emailul pentru link-ul magic de autentificare.",
    "Success! Your account is fully activated, you now have access to all content.": "Succes! Contul tău este complet activat, acum ai acces la tot conținutul.",
    "Success! Your email is updated.": "Succes! Emailul tău a fost actualizat.",
    "Successfully unsubscribed": "Dezabonare realizată cu succes",
    "Taylor Reid": "",
    "taylor@example.com": "",
    "Thank you for subscribing. Before you start reading, below are a few other sites you may enjoy.": "Îți mulțumim pentru abonare. Înainte să începi să citești, iată câteva alte site-uri care s-ar putea să-ți placă.",
    "Thank you for your support": "",
    "Thank you for your support!": "",
    "Thanks for the feedback!": "Mulțumim pentru feedback!",
    "That didn't go to plan": "Asta nu a mers conform planului",
    "The email address we have for you is {memberEmail} — if that's not correct, you can update it in your <button>account settings area</button>.": "Adresa de email pe care o avem pentru tine este {memberEmail} — dacă nu este corectă, o poți actualiza în <button>zona de setări a contului</button>.",
    "There was a problem submitting your feedback. Please try again a little later.": "A fost o problemă cu trimiterea feedback-ului tău. Te rog încearcă din nou puțin mai târziu.",
    "There was an error cancelling your subscription, please try again.": "",
    "There was an error continuing your subscription, please try again.": "",
    "There was an error processing your payment. Please try again.": "",
    "There was an error sending the email, please try again": "",
    "This gift can only be redeemed once and expires on {expiryDate}.": "",
    "This gift has already been consumed.": "",
    "This gift has already been redeemed.": "",
    "This gift has been refunded.": "",
    "This gift has expired.": "",
    "This gift link is invalid.": "",
    "This site is invite-only, contact the owner for access.": "Acest site este disponibil doar pe bază de invitație, contactează proprietarul pentru acces.",
    "This site is not accepting donations at the moment.": "",
    "This site is not accepting payments at the moment.": "",
    "This site only accepts paid members.": "",
    "This unsubscribe link belongs to a different email address than the one you are signed in with.": "",
    "Threads": "",
    "Tier": "",
    "To": "",
    "To complete signup, click the confirmation link in your inbox. If it doesn't arrive within 3 minutes, check your spam folder!": "Pentru a finaliza înregistrarea, apasă pe link-ul de confirmare din inbox-ul tău. Dacă nu ajunge în 3 minute, verifică folderul de spam!",
    "To continue to stay up to date, subscribe to {publication} below.": "",
    "Too many attempts try again in {number} days.": "Prea multe încercări încearcă din nou în {number} zile.",
    "Too many attempts try again in {number} hours.": "Prea multe încercări încearcă din nou în {number} ore.",
    "Too many attempts try again in {number} minutes.": "Prea multe încercări încearcă din nou în {number} minute.",
    "Too many different sign-in attempts, try again in {number} days": "Prea multe încercări de autentificare diferite, încearcă din nou în {number} zile.",
    "Too many different sign-in attempts, try again in {number} hours": "Prea multe încercări de autentificare diferite, încearcă din nou în {number} ore.",
    "Too many different sign-in attempts, try again in {number} minutes": "Prea multe încercări de autentificare diferite, încearcă din nou în {number} minute.",
    "Too many sign-up attempts, try again later": "",
    "Try free for {amount} days, then {originalPrice}.": "Încearcă gratuit pentru {amount} zile, apoi {originalPrice}.",
    "Unable to initiate checkout session": "Nu pot iniția sesiunea de plată.",
    "Unable to verify your request, please try again": "",
    "Unlock access to all newsletters by becoming a paid subscriber.": "Deblochează accesul la toate buletinele informative devenind un abonat plătit.",
    "Unsubscribe from all emails": "Dezabonează-te de la toate emailurile",
    "Unsubscribed": "Dezabonat",
    "Unsubscribed from all emails.": "Dezabonat de la toate email-urile.",
    "Unsubscribing from emails will not cancel your paid subscription to {title}": "Dezabonarea de la emailuri nu va anula abonamentul plătit la {title}",
    "Update": "Actualizează",
    "Update your preferences": "Actualizează-ți preferințele",
    "Updates & announcements": "",
    "Verification link sent, check your inbox": "Link-ul de verificare a fost trimis, verifică-ți inboxul",
    "Verify your email address is correct": "Verifică dacă adresa ta de email este corectă",
    "Verifying...": "",
    "View plans": "Vezi planurile",
    "We couldn't unsubscribe you as the email address was not found. Please contact the site owner.": "Nu am putut să te dezabonăm deoarece adresa de email nu a fost găsită. Te rugăm să contactezi proprietarul site-ului.",
    "We'd hate to see you leave. How about a special offer to stay?": "",
    "We'll email it to the recipient on {deliveryDate}. A copy is in your inbox too.": "",
    "We'll email it to the recipient. A copy will be in your inbox too.": "",
    "Welcome back, {name}!": "Bun revenit, {name}!",
    "Welcome back!": "Bun revenit!",
    "Welcome to {siteTitle}": "Bun venit la {siteTitle}",
    "What's included": "",
    "When an inbox fails to accept an email it is commonly called a bounce. In many cases, this can be temporary. However, in some cases, a bounced email can be returned as a permanent failure when an email address is invalid or non-existent.": "Când o cutie poștală eșuează în a accepta un email, acesta este de obicei numit un bounce. În multe cazuri, acesta poate fi temporar. Totuși, în unele cazuri, un email returnat poate fi considerat o defecțiune permanentă când o adresă de email este invalidă sau inexistență.",
    "Why has my email been disabled?": "De ce a fost dezactivat emailul meu?",
    "X (Twitter)": "",
    "year": "",
    "Yearly": "Anual",
    "You already have an active subscription.": "",
    "You currently have a free membership, upgrade to a paid subscription for full access.": "În prezent ai o membră tate gratuită, upgradează la un abonament plătit pentru acces complet.",
    "You have been successfully resubscribed": "Te-ai reabonat cu succes",
    "You now have access to {tierName} until {expiryDate}. Enjoy!": "",
    "You're currently not receiving emails": "În prezent nu primești emailuri",
    "You're not receiving emails": "Nu primești emailuri",
    "You're not receiving emails because you either marked a recent message as spam, or because messages could not be delivered to your provided email address.": "Nu primești emailuri deoarece fie ai marcat un mesaj recent ca spam, fie pentru că mesajele nu pot fi livrate la adresa ta de email furnizată.",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership_one": "",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership_few": "",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership_other": "",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_one": "",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_few": "",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_other": "",
    "You've been gifted a <strong>{duration}-year</strong> {tierName} membership": "",
    "You've been gifted a <strong>{duration}-year</strong> {tierName} membership to {siteTitle}": "",
    "You've successfully signed in.": "Te-ai autentificat cu succes.",
    "You've successfully subscribed to <strong>{siteTitle}</strong>": "Te-ai abonat cu succes la <strong>{siteTitle}</strong>",
    "Your account": "Contul tău",
    "Your email": "",
    "Your email has failed to resubscribe, please try again": "",
    "Your gift is on its way": "",
    "Your gift is ready": "",
    "Your gift is scheduled": "",
    "Your gift subscription will expire on {expiryDate}": "",
    "your inbox": "",
    "Your input helps shape what gets published.": "Contribuția ta ajută la conturarea a ceea ce se publică.",
    "Your name": "",
    "Your subscription has been canceled and will expire on {expiryDate}.": "",
    "Your subscription will expire on {expiryDate}": "Abonamentul tău va expira pe {expiryDate}",
    "Your subscription will renew on {renewalDate}": "Abonamentul tău se va reînnoi pe {renewalDate}",
    "Your subscription will start on {subscriptionStart}": "Abonamentul tău va începe pe {subscriptionStart}"
}
